export default "__VITE_ASSET__B6BF0_5I__"